<script>
export default {
    name: 'LumpingAndSplittingLink',
}
</script>
<template>
  <a
    target="lumping-splitting-guidelines"
    href="https://clinicalgenome.org/working-groups/lumping-and-splitting/"
  >
    <slot>ClinGen Lumping and Splitting guidance</slot>
  </a>
</template>